import React, { useMemo, useState, useCallback, useRef, useEffect, useContext } from 'react';
import { useWavesurfer } from '@wavesurfer/react';
import Timeline from 'wavesurfer.js/dist/plugins/timeline.esm.js'
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.esm.js'
import { Icon } from "@iconify/react";


// old imports
import { generateRandomNumber } from '../../utils/generateRandomNumber';
import { formatTimeInHHMMSS, formatTimeWithOptionalHours, timeStringToSeconds } from "../../utils/timeFile"
import SidebarContext from '../../contexts/MyContext';
import { AudioHandler } from '../../Apihander/AudioRecording/AudioRecording';
import { successToast } from '../../utils/notificationUtils';
import { errorToast } from '../../utils/notificationUtils';
import Loader from '../../animations/Loader';
import { convertToMp3 } from '../../pages/RecordingFeatures/convertToMp3';
import "./WaveForm.css"



import Modal from '../Modal/Modal';



// onTrimPlay refuses a shorter selection, so the handles stop there too.
const MIN_TRIM_SECONDS = 3;

// The encoder decodes through an AudioContext, which a hidden tab can suspend indefinitely.
const MP3_ENCODE_TIMEOUT_MS = 30000;

// Module-level so useWavesurfer sees a stable option identity and does not rebuild.
const TRIM_WAVE_COLOR = '#C7CBE6';
const TRIM_PROGRESS_COLOR = '#334155';

const formatTime = (seconds) =>
    [Math.floor(seconds / 60), Math.floor(seconds % 60)]
        .map((v) => `0${v}`.slice(-2))
        .join(':');


const WaveFormNew = ({ audioName, audioUrl, audioId, startTime, folderId, selectedTrimAudio, isPrevDisabled, isNextDisabled, playPreviousTrack, playNextTrack }) => {
    const containerRef = useRef(null);
    const abortControllerRef = useRef(null);
    const [activeRegion, setActiveRegion] = useState(null);
    const [originalUrl, setOriginalUrl] = useState(audioUrl);
    const [trimmedUrl, setTrimmedUrl] = useState(null);
    const [totalDuration, setTotalDuration] = useState(0);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [volume, setVolume] = useState(1);
    const [trimUrl, setTrimUrl] = useState()
    //old component state
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [trimTime, setTrimTime] = useState(null);
    const [audioBlobUrl, setAudioBlobUrl] = useState(null);
    const [recordingName, setRecordingName] = useState("");
    const { selectedFormat, setAudioData, setActionTabIndex, setAudio, audio, setFilterAudioData, audioIndex, setAudioIndex, filterAudioData, favoriteAudio, listTabIndex, setTabIndex } = useContext(SidebarContext);

    // A file picked in AI Tools has never been uploaded, so it has no id to trim against on the server.
    const isLocalUpload = selectedTrimAudio?.isLocalUpload === true;

    // A save in flight locks every other control on the trim screen.
    const isSaving = loading || load;

    // The trim screen unmounts as the save finishes, so the toast waits for that render to settle.
    const notifyAfterRender = (notify) => setTimeout(notify, 0);

    // The api handlers resolve with the axios error instead of throwing, so failures are read off the same value.
    const saveErrorMessage = (data) =>
        data?.response?.data?.error || data?.response?.data?.message || data?.message || 'Something went wrong. Please try again.';

    const iconStartRef = useRef(null);
    const iconEndRef = useRef(null);
    const regionId = 'trimRegion';


    // const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    const proxyUrl = "";
    const startPercentage = 0.25;
    const endPercentage = 0.50;

    const trimHandleStyle = {
        position: 'absolute',
        top: '-32px',
        left: 0,
        transform: 'translateX(-50%)',
        backgroundColor: '#334155',
        width: '32px',
        borderRadius: '50%',
        padding: '5px',
        zIndex: 5,
        cursor: 'ew-resize',
        touchAction: 'none',
        userSelect: 'none',
    };



    const { wavesurfer, isPlaying, currentTime } = useWavesurfer({
        container: containerRef,
        height: 112,
        waveColor: TRIM_WAVE_COLOR,
        progressColor: TRIM_PROGRESS_COLOR,
        cursorColor: '#334155',
        cursorWidth: 2,
        url: trimmedUrl || originalUrl,
        barHeight: 2,
        barWidth: 2,
        barGap: 2,
        barRadius: 2,
        crossOrigin: 'anonymous',
        plugins: useMemo(() => [
            Timeline.create(),
            RegionsPlugin.create({
                dragSelection: {
                    color: 'rgba(255, 0, 0, 0.1)',
                },
            }),
        ], []),
    });



    const onTrimPlay = async () => {
        // CORS-safe audio fetch
        const fetchAudioWithCORS = async (url) => {
            const response = await fetch(url, {
                // mode: 'cors',
                // headers: { 'Access-Control-Allow-Origin': '*' },
            });
            return response;
        };

        if (activeRegion && wavesurfer) {
            setIsLoading(true);
            abortControllerRef.current = new AbortController();

            try {
                const start = activeRegion.start;
                const end = activeRegion.end;
                const selectedTime = end - start;
                setTrimTime(selectedTime)



                if (selectedTime >= 3) {
                    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                    const response = await fetchAudioWithCORS(originalUrl);

                    if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
                    const arrayBuffer = await response.arrayBuffer();
                    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

                    const startOffset = Math.floor(start * audioBuffer.sampleRate);
                    const endOffset = Math.floor(end * audioBuffer.sampleRate);
                    const length = endOffset - startOffset;

                    const trimmedBuffer = audioContext.createBuffer(
                        audioBuffer.numberOfChannels,
                        length,
                        audioBuffer.sampleRate
                    );

                    for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
                        const channelData = audioBuffer.getChannelData(channel);
                        trimmedBuffer.copyToChannel(channelData.subarray(startOffset, endOffset), channel);
                    }

                    const trimmedBlob = await audioBufferToWave(trimmedBuffer);
                    const trimmedUrl = URL.createObjectURL(trimmedBlob);

                    wavesurfer.load(trimmedUrl);
                    setAudioBlobUrl(trimmedBlob)
                    wavesurfer.on('ready', () => URL.revokeObjectURL(trimmedUrl));

                } else {
                    errorToast("Please select an audio duration longer than 3 seconds.")
                }
            } catch (err) {
                if (err.name === 'AbortError') console.log('Fetch aborted');
                else setError(`Error trimming audio: ${err.message}`);
            } finally {
                setIsLoading(false);
                abortControllerRef.current = null;
            }
        }
    };

    const updateIconPositions = useCallback((region) => {
        if (!wavesurfer || !containerRef.current || !region) return;

        const waveformWidth = containerRef.current.clientWidth;
        const duration = wavesurfer.getDuration();

        const startPos = (region.start / duration) * waveformWidth;
        const endPos = (region.end / duration) * waveformWidth;

        if (iconStartRef.current) {
            iconStartRef.current.style.left = `${startPos}px`;
        }
        if (iconEndRef.current) {
            iconEndRef.current.style.left = `${endPos}px`;
        }

    }, [wavesurfer]);

    // Each handle drags its own edge, so the user picks the start and the end of the trim.
    const onHandleDrag = (side) => (event) => {
        if (!activeRegion || !wavesurfer || !containerRef.current) return;
        event.preventDefault();

        const duration = wavesurfer.getDuration();
        const minLength = Math.min(MIN_TRIM_SECONDS, duration);

        const timeAtPointer = (clientX) => {
            const { left, width } = containerRef.current.getBoundingClientRect();
            const ratio = Math.min(Math.max((clientX - left) / width, 0), 1);
            return ratio * duration;
        };

        const onPointerMove = (moveEvent) => {
            const time = timeAtPointer(moveEvent.clientX);
            const start = side === 'start' ? Math.min(time, activeRegion.end - minLength) : activeRegion.start;
            const end = side === 'end' ? Math.max(time, activeRegion.start + minLength) : activeRegion.end;

            activeRegion.setOptions({ start: Math.max(start, 0), end: Math.min(end, duration) });
            updateIconPositions(activeRegion);
        };

        const stopDrag = () => {
            document.removeEventListener('pointermove', onPointerMove);
            document.removeEventListener('pointerup', stopDrag);
        };

        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', stopDrag);
    };

    useEffect(() => {
        if (!wavesurfer) return;
        setIsLoading(true)
        const handleReady = () => {
            setTotalDuration(wavesurfer.getDuration());
            wavesurfer.play()
            setError(null);
            setIsLoading(false)

            const regionsPlugin = wavesurfer.plugins.find(p => p instanceof RegionsPlugin);
            if (regionsPlugin) {
                regionsPlugin.clearRegions();
                const newRegion = regionsPlugin.addRegion({
                    id: regionId,
                    start: wavesurfer.getDuration() * startPercentage,
                    end: wavesurfer.getDuration() * endPercentage,

                    color: "rgba(6, 182, 212, 0.14)",
                    drag: true,
                    resize: true,

                });
                setActiveRegion(newRegion);
                updateIconPositions(newRegion);
                newRegion.on('update', () => updateIconPositions(newRegion));
            }
        };

        const handleError = (err) => {
            console.error('Wavesurfer error:', err);
            setError(`Error loading audio: ${err.message}`);
            // Without this the play button spins forever on a file that never loads.
            setIsLoading(false);
        };
        const handleRegionUpdate = (region) => {
            updateIconPositions(region);
        };

        const fileExtension = audioName?.split('.').pop().toLowerCase()
        if (fileExtension === "caf" || fileExtension === "m4a") {
            wavesurfer.seekTo(0);
            setOriginalUrl()

        } else {
            setOriginalUrl(audioUrl)
        }

        if (wavesurfer) {
            wavesurfer.on('ready', handleReady);
            wavesurfer.on('region-update', handleRegionUpdate);


        }
        wavesurfer.on('error', handleError);

        return () => {
            if (wavesurfer) {
                wavesurfer.un('ready', handleReady);
                wavesurfer.un('error', handleError);
                wavesurfer.on('region-update', handleRegionUpdate);
                if (wavesurfer.isReady) {
                    wavesurfer.destroy();
                    containerRef.current.destroy()
                }
            }
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();

                setIsLoading(false)
            }
        };
    }, [wavesurfer, audioUrl, originalUrl, updateIconPositions]);



    useEffect(() => {
        if (wavesurfer) {
            wavesurfer.setVolume(volume);
        }
    }, [volume, wavesurfer]);




    useEffect(() => {
        if (wavesurfer) {
            wavesurfer.on('ready', updateIconPositions);
            wavesurfer.on('region-update-end', updateIconPositions);
            wavesurfer.on('region-updated', updateIconPositions);

            // Cleanup listeners on component unmount
            return () => {
                wavesurfer.destroy();
            };
        }
    }, [wavesurfer, updateIconPositions]);

    const onPlayPause = useCallback(() => {
        wavesurfer && wavesurfer.playPause();
    }, [wavesurfer]);




    const onReset = () => {
        try {
            // setTrimmedUrl(null);
            setError(null);
            wavesurfer.load(audioUrl);
            wavesurfer.on('ready', () => {
                wavesurfer.play();
            });
        } catch (e) {
            if (e.name !== 'AbortError') {
                console.error('Error loading audio', e);
            } else {
                setError(e.message);
            }
        } finally {
            setIsLoading(false);
            setAudioBlobUrl("")
            abortControllerRef.current = null;
        }
    };

    async function audioBufferToWave(abuffer) {
        const numOfChan = abuffer.numberOfChannels;
        const length = abuffer.length * numOfChan * 2 + 44;
        const buffer = new ArrayBuffer(length);
        const view = new DataView(buffer);
        const channels = [];
        let offset = 0;
        let pos = 0;

        setUint32(0x46464952);
        setUint32(length - 8);
        setUint32(0x45564157);
        setUint32(0x20746d66);
        setUint32(16);
        setUint16(1);
        setUint16(numOfChan);
        setUint32(abuffer.sampleRate);
        setUint32(abuffer.sampleRate * 2 * numOfChan);
        setUint16(numOfChan * 2);
        setUint16(16);
        setUint32(0x61746164);
        setUint32(length - pos - 4);

        for (let i = 0; i < abuffer.numberOfChannels; i++) {
            channels.push(abuffer.getChannelData(i));
        }

        while (pos < length) {
            for (let i = 0; i < numOfChan; i++) {
                let sample = Math.max(-1, Math.min(1, channels[i][offset]));
                sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767) | 0;
                view.setInt16(pos, sample, true);
                pos += 2;
            }
            offset++;
        }

        return new Blob([buffer], { type: "audio/wav" });

        function setUint16(data) {
            view.setUint16(pos, data, true);
            pos += 2;
        }

        function setUint32(data) {
            view.setUint32(pos, data, true);
            pos += 4;
        }
    }

    // const handleSeek = (event) => {
    //     const { clientX } = event;
    //     const boundingRect = event.target.getBoundingClientRect();
    //     const x = clientX - boundingRect.left;
    //     const percentage = x / boundingRect.width;
    //     const seekTime = percentage * totalDuration;

    //     if (wavesurfer) {
    //         wavesurfer.seekTo(percentage);
    //     }
    // };

    const handleSeek = (event) => {
        const newTime = (event.target.value / 100) * totalDuration; // Convert range percentage to time
        wavesurfer.seekTo(newTime / totalDuration);

    };
    const skipForward = () => {
        if (wavesurfer) {
            const newTime = Math.min(currentTime + 5, totalDuration);
            wavesurfer.seekTo(newTime / totalDuration);
        }
    };

    const skipBackward = () => {
        if (wavesurfer) {
            const newTime = Math.max(currentTime - 5, 0);
            wavesurfer.seekTo(newTime / totalDuration);
        }
    }

    const handleOpen = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);

    // The trimmed blob is uploaded as a brand new recording, since the original was never saved.
    const doSaveLocalTrimAudio = async () => {
        const dotIndex = audioName?.lastIndexOf('.') ?? -1;
        const baseName = dotIndex > 0 ? audioName.substring(0, dotIndex) : (audioName || `Trimmed${generateRandomNumber()}`);

        try {
            setLoading(true);

            // The trimmed blob is raw wav, roughly ten times the size of the mp3 recordings are saved as.
            let uploadBlob = audioBlobUrl;
            let trimmedFileName = `${baseName}.mp3`;
            let encodeTimer;
            try {
                // Bounded so a stalled encode cannot leave the save hanging without a notification.
                uploadBlob = await Promise.race([
                    convertToMp3(audioBlobUrl),
                    new Promise((_, reject) => {
                        encodeTimer = setTimeout(() => reject(new Error('MP3 encoding timed out')), MP3_ENCODE_TIMEOUT_MS);
                    }),
                ]);
            } catch (conversionError) {
                // Falls back to the raw wav so a failed encode still saves the trim.
                uploadBlob = audioBlobUrl;
                trimmedFileName = `${baseName}.wav`;
            } finally {
                clearTimeout(encodeTimer);
            }

            var formData = new FormData();

            formData.append('audiofile', new File([uploadBlob], trimmedFileName), trimmedFileName);
            formData.append('timeDuration', formatTimeInHHMMSS(trimTime));
            formData.append('action', 'Trim');
            formData.append('isFavourite', false);
            formData.append('hasnote', 'false');
            // Lets the backend suffix the name instead of rejecting a duplicate.
            formData.append('isRename', 'true');

            const data = await AudioHandler.doUploadAudioUrl(formData);

            if (data?.statusCode === 200) {
                setOpenModal(false);
                setRecordingName('');
                setFilterAudioData((prev) => [data?.data, ...prev]);
                setLoading(false);
                URL.revokeObjectURL(originalUrl);
                setActionTabIndex(null);
                setAudio();
                // The saved recording lives in My Recordings, the same tab the other AI tools land on.
                setTabIndex(2);
                // Fired after the screen swap commits, so the toast is not mounted into the tear-down render.
                notifyAfterRender(() => successToast(data?.message || 'Trimmed audio saved successfully'));
            } else {
                errorToast(saveErrorMessage(data));
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            errorToast(saveErrorMessage(error));
            console.log("🚀 ~ doSaveLocalTrimAudio ~ error:", error);
        }
    };

    const doHandalTrimAudioUrlNew = async (id, type, folderId) => {

        const randomAudioName = `Trimmed${generateRandomNumber()}`;
        const trimmedRecordingName = randomAudioName.trim();
        try {
            setLoading(true)
            var formData = new FormData();

            formData.append('audioId', id);
            formData.append('type', type)
            formData.append('timeDuration', formatTimeInHHMMSS(trimTime))
            // formData.append('file', audioBlobUrl, `${trimmedRecordingName}.${selectedFormat}`);
            const audioFile = new File([audioBlobUrl], `${trimmedRecordingName}.${selectedFormat}`);
            formData.append('audiofile', audioFile);
            formData.append('action', 'Trim')
            const data = await AudioHandler.doHandalTrimAudio(formData, folderId);

            if (data.statusCode === 200) {
                setOpenModal(false);
                setRecordingName('');
                setFilterAudioData((prev) => [data.data, ...prev]);
                setLoading(false)
                setActionTabIndex(null);
                setAudio()
                notifyAfterRender(() => successToast(data.message));
            }
            else {
                errorToast(saveErrorMessage(data))
                setLoading(false)

            }
        } catch (error) {
            setLoading(false)
            errorToast(saveErrorMessage(error));
            console.log("🚀 ~ doHandalUploadAudioUrl ~ error:", error);
        }
    };

    const doHandalTrimAudioUrlExisting = async (id, type, folderId, name) => {
        const dotIndex = name.lastIndexOf('.');
        let baseName = name;
        let fileFormat = selectedFormat;

        // If a dot was found, split the name into base name and format
        if (dotIndex !== -1) {
            baseName = name.substring(0, dotIndex);
            fileFormat = name.substring(dotIndex + 1);
        }

        const randomAudioName = `Trimmed${generateRandomNumber()}`;
        const trimmedRecordingName = randomAudioName.trim();

        try {
            setLoad(true)
            var formData = new FormData();

            formData.append('audioId', id);
            formData.append('type', type)
            formData.append('timeDuration', formatTimeInHHMMSS(trimTime))

            const audioFile = new File([audioBlobUrl], `${baseName}.${fileFormat}`);
            formData.append('audiofile', audioFile);
            formData.append('action', 'Trim');

            const data = await AudioHandler.doHandalTrimAudio(formData, folderId);
            if (data?.statusCode === 200) {
                setOpenModal(false);
                setRecordingName('');
                // setFilterAudioData((prev) => {
                //     // Remove the temporary file and add the actual file from the response
                //     const updatedFiles = prev.filter(file => file._id !== id);
                //     return [data?.data, ...updatedFiles];
                // });
                setFilterAudioData((prev) => {
                    // Find the index of the existing audio file in the state
                    const index = prev.findIndex(file => file._id === id);

                    if (index !== -1) {
                        // Create a new array with the updated audio data at the same index
                        const updatedFiles = [...prev];
                        updatedFiles[index] = data?.data;  // Replace the audio at the found index with the new data
                        return updatedFiles;
                    }
                    return prev; // If the file is not found, return the existing state unchanged
                });
                setActionTabIndex(null);
                setAudio();
                setLoad(false);
                notifyAfterRender(() => successToast(data.message));
            } else {
                errorToast(saveErrorMessage(data));
                setLoad(false);
            }
        } catch (error) {
            setLoad(false);
            errorToast(saveErrorMessage(error));
            console.log("🚀 ~ doHandalTrimAudioUrlExisting ~ error:", error);
        }
    };

    // const doHandalTrimAudioUrlExisting = async (id, type, folderId, name) => {
    //     debugger
    //     const randomAudioName = `Trimmed${generateRandomNumber()}`;
    //     const trimmedRecordingName = randomAudioName.trim();

    //     try {
    //         setLoad(true)
    //         var formData = new FormData();

    //         formData.append('audioId', id);
    //         formData.append('type', type)
    //         formData.append('timeDuration', formatTimeInHHMMSS(trimTime))
    //         const audioFile = new File([audioBlobUrl], `${name}.${selectedFormat}`);
    //         formData.append('audiofile', audioFile)
    //         formData.append('action', 'Trim')
    //         const data = await AudioHandler.doHandalTrimAudio(formData, folderId);
    //         if (data.status) {
    //             setOpenModal(false);
    //             setRecordingName('');
    //             successToast(data.message);
    //             setFilterAudioData((prev) => {
    //                 // Remove the temporary file and add the actual file from the response
    //                 const updatedFiles = prev.filter(file => file._id !== id);
    //                 return [data?.data, ...updatedFiles];
    //             });
    //             setActionTabIndex(null);
    //             setAudio()
    //             setLoad(false)

    //         }
    //     } catch (error) {
    //         setLoad(false)
    //         console.log("🚀 ~ doHandalUploadAudioUrl ~ error:", error);
    //     }
    // };
    const buttonStyle = {
        margin: '0 10px',
        padding: '5px 15px',
        backgroundColor: '#334155',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        height: '90px',
        width: '90px',
        cursor: 'pointer',
    };

    return (
        <>
            <div className="vr-edit-trim">

                <div className="vr-edit-card vr-edit-wavecard">
                    <div className="vr-edit-topbar">
                        <div className="vr-edit-volume">
                            <Icon icon="lucide:volume-2" width={18} height={18} role="img" aria-label="volume" />
                            <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.01"
                                value={volume}
                                onChange={(e) => setVolume(parseFloat(e.target.value))}
                                disabled={isSaving}
                                className="volume-slider"
                                style={{
                                    background: `linear-gradient(to right, #334155 0%, #334155 ${volume * 100}%, #DDE1EE ${volume * 100}%, #DDE1EE 100%)`,
                                }}
                            />
                        </div>
                    </div>
                    {/* <div ref={containerRef} style={{ margin: "10px 0px", backgroundColor: "#F8FAFC" }}></div>
                {error && <p style={{ color: 'red' }}>{error}</p>} */}

                    <div className="vr-edit-wave">
                        <div ref={containerRef}></div>

                        <img
                            ref={iconStartRef}
                            src="/img/trim/startIcon.png"
                            alt="Start Trim Icon"
                            draggable={false}
                            className="vr-edit-handle"
                            onPointerDown={isSaving ? undefined : onHandleDrag('start')}
                            style={{ ...trimHandleStyle, visibility: activeRegion ? 'visible' : 'hidden', pointerEvents: isSaving ? 'none' : 'auto' }}
                        />
                        <img
                            ref={iconEndRef}
                            src="/img/trim/startIcon.png"
                            alt="End Trim Icon"
                            draggable={false}
                            className="vr-edit-handle"
                            onPointerDown={isSaving ? undefined : onHandleDrag('end')}
                            style={{ ...trimHandleStyle, visibility: activeRegion ? 'visible' : 'hidden', pointerEvents: isSaving ? 'none' : 'auto' }}
                        />
                    </div>

                    <div className="vr-edit-times">
                        <span className="vr-edit-time is-current">{formatTime(currentTime)}</span>
                        <span className="vr-edit-time">{formatTime(totalDuration)}</span>
                    </div>

                    <div>
                        <input
                            type="range"
                            min="0"
                            max="100"
                            value={(currentTime / totalDuration) * 100 || 0}
                            onChange={handleSeek}
                            disabled={isSaving}
                            className="seekbar"
                            style={{
                                background: `linear-gradient(to right, #334155 0%, #334155 ${(currentTime / totalDuration) * 100}%, #DDE1EE ${(currentTime / totalDuration) * 100}%, #DDE1EE 100%)`,
                            }}
                        />
                    </div>

                    <div className="vr-edit-transport">

                        <div className="vr-edit-nav">
                            <img
                                src={isLoading || isSaving || isPrevDisabled ? "/img/dashboard/disabled_previous.png" : "/img/dashboard/previous.png"}
                                width="36px"
                                height="36px"
                                style={{ cursor: isLoading || isSaving || isPrevDisabled ? "not-allowed" : "pointer" }}
                                onClick={!isLoading && !isSaving && !isPrevDisabled ? playPreviousTrack : undefined}
                                alt="prev"
                            />
                        </div>

                        <button onClick={skipBackward} disabled={isSaving} className="vr-edit-skip">
                            <img src="/img/trim/backward.png" alt="Backward" />
                        </button>

                        <button onClick={onPlayPause} disabled={isSaving} className="vr-edit-play">
                            {isLoading ? (
                                <Loader />
                            ) : (
                                <img
                                    src={isPlaying ? "/img/trim/pause.png" : "/img/trim/play.png"}
                                    alt={isPlaying ? "Pause" : "Play"}
                                />
                            )}
                        </button>

                        <button onClick={skipForward} disabled={isSaving} className="vr-edit-skip">
                            <img src="/img/trim/forward.png" alt="Forward" />
                        </button>

                        <div className="vr-edit-nav">
                            <img
                                src={isLoading || isSaving || isNextDisabled ? "/img/dashboard/disabled_next.png" : "/img/dashboard/next.png"}
                                width="36px"
                                height="36px"
                                style={{ cursor: isLoading || isSaving || isNextDisabled ? "not-allowed" : "pointer" }}
                                onClick={!isLoading && !isSaving && !isNextDisabled ? playNextTrack : undefined}
                                alt="next"
                            />
                        </div>
                    </div>
                </div>

                <div className="vr-edit-actions">
                    <button
                        className="vr-btn vr-btn-ghost"
                        disabled={!audioBlobUrl || isSaving}
                        onClick={onReset}
                    >
                        <Icon icon="lucide:rotate-ccw" width={18} height={18} />
                        <span>
                            Reset
                        </span>
                    </button>
                    <button
                        className="vr-btn vr-btn-tone"
                        disabled={isSaving}
                        onClick={onTrimPlay}
                    >
                        <Icon icon="lucide:scissors" width={18} height={18} />
                        <span>
                            Trim
                        </span>
                    </button>
                    <button
                        className="vr-btn vr-btn-primary"
                        onClick={() => {
                            if (isLocalUpload) {
                                if (!loading) doSaveLocalTrimAudio();
                                return;
                            }
                            setOpenModal(true)

                        }}
                        disabled={!audioBlobUrl || isSaving}
                    >

                        {isLocalUpload && isSaving ? (
                            <div
                                className="spinner-border"
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        ) : (
                            <Icon icon="lucide:download" width={18} height={18} role="img" aria-label="Save" />
                        )}
                        <span>
                            Save
                        </span>
                    </button>
                </div>



                {openModal && (
                    <Modal onClose={handleClose} modaltxt={"Save recording"}
                        closeButtonDisabled={isSaving}
                    >
                        <div className="vr-edit-modal">
                            <div className="form-group">
                                <button
                                    type="submit"
                                    disabled={isButtonDisabled || isSaving}
                                    className="vr-btn vr-btn-primary vr-btn-block"
                                    onClick={(e) => {
                                        if (!loading) {
                                            doHandalTrimAudioUrlNew(audioId, "new", folderId);
                                        }
                                    }}

                                >
                                    {loading ? (
                                        <>
                                            <div
                                                className="spinner-border"
                                                role="status"
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <span>
                                                Save as a new file
                                            </span>
                                        </>
                                    )
                                    }
                                </button>
                            </div>
                            <div className="form-group vr-edit-or">
                                <span>
                                    OR
                                </span>
                            </div>
                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="vr-btn vr-btn-secondary vr-btn-block"
                                    disabled={isButtonDisabled || isSaving}
                                    onClick={(e) => {
                                        if (!load) {
                                            doHandalTrimAudioUrlExisting(audioId, "existing", folderId, audioName);
                                        }
                                    }}
                                >
                                    {load ? (
                                        <>
                                            <div
                                                className="spinner-border"
                                                role="status"
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <span>
                                                Overwrite existing file
                                            </span>
                                        </>
                                    )
                                    }
                                </button>
                            </div>

                            <div className="form-group vr-edit-modal-foot">
                                <button
                                    type="submit"
                                    className="vr-btn vr-btn-ghost vr-btn-block"
                                    disabled={isSaving}
                                    onClick={(e) => {
                                        handleClose()
                                    }}
                                >
                                    <span>
                                        Cancel
                                    </span>
                                </button>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        </>
    );
};



export default WaveFormNew;